import { createContext, useContext, useEffect, useState } from "react";

// AED is base currency. Approximate conversion rates (would be live API in production).
const RATES = {
  AED: { rate: 1, symbol: "AED", label: "AED د.إ" },
  USD: { rate: 0.272, symbol: "$", label: "$ USD" },
  EUR: { rate: 0.252, symbol: "€", label: "€ EUR" },
  GBP: { rate: 0.215, symbol: "£", label: "£ GBP" },
  SAR: { rate: 1.02, symbol: "SAR", label: "SAR ر.س" },
  INR: { rate: 22.6, symbol: "₹", label: "₹ INR" },
};

const STRINGS = {
  en: {
    track_shipment: "Track Shipment",
    all_categories: "All Categories",
    search_placeholder: "Search brand, model, reference…",
    wishlist: "Wishlist",
    cart: "Cart",
    track_order: "Track Order",
    account: "Account",
    shop_by_brands: "Shop by Brands",
    watches: "Watches",
    handbags: "Handbags",
    leather_goods: "Leather Goods",
    accessories: "Accessories",
    brand_new: "Brand New",
    blog: "Blog",
    support: "Support",
    add_to_cart: "Add to Cart",
    buy_now: "Buy Now",
    shop_collection: "Shop the Collection",
    view_all: "View All",
    new_arrivals: "New Arrivals",
    featured: "Featured",
    sign_in: "Sign in",
    sign_up: "Create account",
    home: "Home",
    about: "About",
    contact: "Contact",
    services: "Services",
  },
  ar: {
    track_shipment: "تتبع الشحنة",
    all_categories: "جميع الفئات",
    search_placeholder: "ابحث عن الماركة، الموديل…",
    wishlist: "المفضلة",
    cart: "السلة",
    track_order: "تتبع الطلب",
    account: "الحساب",
    shop_by_brands: "تسوق حسب الماركة",
    watches: "الساعات",
    handbags: "الحقائب",
    leather_goods: "المنتجات الجلدية",
    accessories: "الإكسسوارات",
    brand_new: "جديد",
    blog: "المدونة",
    support: "الدعم",
    add_to_cart: "أضف إلى السلة",
    buy_now: "اشتري الآن",
    shop_collection: "تسوق المجموعة",
    view_all: "عرض الكل",
    new_arrivals: "وصل حديثاً",
    featured: "المميز",
    sign_in: "تسجيل الدخول",
    sign_up: "إنشاء حساب",
    home: "الرئيسية",
    about: "حول",
    contact: "تواصل",
    services: "الخدمات",
  },
};

const LocaleContext = createContext({});

export const LocaleProvider = ({ children }) => {
  const [currency, setCur] = useState(() => localStorage.getItem("currency") || "AED");
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => { localStorage.setItem("currency", currency); }, [currency]);
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const setCurrency = (c) => setCur(c);
  const setLang = (l) => setLangState(l);

  const fmt = (aedAmount) => {
    const r = RATES[currency] || RATES.AED;
    const v = (aedAmount || 0) * r.rate;
    const rounded = v >= 100 ? Math.round(v) : Math.round(v * 100) / 100;
    return `${r.symbol} ${rounded.toLocaleString()}`;
  };

  const t = (key) => (STRINGS[lang] || STRINGS.en)[key] || STRINGS.en[key] || key;

  return (
    <LocaleContext.Provider value={{ currency, setCurrency, lang, setLang, fmt, t, currencies: Object.keys(RATES), rates: RATES }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);
